import AuditUseCase from "./AuditUseCase";

export function auditUseCase() {
  return new AuditUseCase();
}
